import React, { PropTypes, Component } from 'react'
import Link from 'react-router/lib/Link'
import Table from 'react-bootstrap/lib/Table'
import Print from 'react-icons/lib/md/print'
import acc from 'accounting'

import FormContainerFee from './form-container-fee'
import ListFeeItem from './list-fee-item'

class ListFees extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openForm: false,
      item: null,
    }
  }

  _openForm = () => {
    this.setState({
      openForm: true,
      item: null,
    })
  }

  _closeForm = () => {
    this.setState({
      openForm: false,
      item: null,
    })
  }

  _onSelectItem = (item) => {
    this.setState({
      item,
      openForm: true,
    })
  }

  _renderForm() {
    const { openForm, item } = this.state
    const { id } = this.props

    if (!openForm) {
      return null
    }

    return (
      <FormContainerFee
        id={id}
        item={item}
        close={this._closeForm}
        handleClose={() => this.setState({ openForm: false })}
      />
    )
  }

  _renderList() {
    const { fees, total } = this.props

    return (
      <Table hover condensed>
        <thead>
          <tr>
            <th width="20">#</th>
            <th>Fee Code</th>
            <th>Fee Description</th>
            <th className="text-right">Amount (Php)</th>
          </tr>
        </thead>
        <tbody>
          { fees && fees.map((fee, i) => (
            <ListFeeItem
              key={fee.get('id')}
              item={fee}
              k={i}
              onSelectItem={this._onSelectItem}
            />
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th className="text-right" colSpan="3">Total:</th>
            <th className="text-right">{acc.formatNumber(total, 2)}</th>
          </tr>
        </tfoot>
      </Table>
    )
  }

  render() {
    const { id } = this.props

    return (
      <div>
        <div className="row m-b-20">
          <div className="col-sm-6">
            <button type="button" onClick={this._openForm} className="btn btn-info">Add Fee</button>
          </div>
          <div className="col-sm-6 text-right">
            <Link to={`/print/payment-schemes/${id}`} target="_blank" className="btn btn-icon"><Print /></Link>
          </div>
        </div>
        {this._renderList()}
        {this._renderForm()}
        <footer className="text-muted">
          <em><strong>Important!</strong> Tuition Fee and Laboratory Fee is dependent on the units.</em>
        </footer>
      </div>
    )
  }
}

ListFees.propTypes = {
  id: PropTypes.number,
  fees: PropTypes.object,
  total: PropTypes.number,
}

export default ListFees



// WEBPACK FOOTER //
// ./src/containers/Manage/PaymentSchemes/list-fees.js